import { render, staticRenderFns } from "./WalletOpend.vue?vue&type=template&id=641ef2a5&scoped=true&"
import script from "./WalletOpend.vue?vue&type=script&lang=ts&"
export * from "./WalletOpend.vue?vue&type=script&lang=ts&"
import style0 from "./WalletOpend.vue?vue&type=style&index=0&id=641ef2a5&lang=less&scoped=true&"
import style1 from "./WalletOpend.vue?vue&type=style&index=1&id=641ef2a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641ef2a5",
  null
  
)

export default component.exports